export default {
    defaultChainID: 1337,
    walletconnectRPC: {
        1: "https://eth-mainnet.alchemyapi.io/v2/_-mMjxdfTD-C6NBe24iwXsLFelLocsei",
        4: "https://eth-rinkeby.alchemyapi.io/v2/EfE4GgSS1wdCAGanz3uOt3SiBA0g4m9R",
        128: "https://http-mainnet-node.huobichain.com",
        256: 'https://http-testnet.hecochain.com'
    },
    baseApi: {
        4: 'https://mintclub.art/api/creature/'
    },
    chainInfo: {
        1: 'Ethereum Mainnet',
        3: 'Ropsten Test Network',
        4: 'Rinkeby Test Network',
        256: 'Huobi Test Network',
        128: 'Huobi Main Network',
        1337:'local'
    },
    // 普通用户
    normalRequestBaseUrl: 'https://mintclub.art',
    // 艺术家
    artistRequestBaseUrl: 'https://artist.mintclub.art',
    // 管理员
    adminRequestBaseUrl: 'https://manage.mintclub.art',
};